import Languages from '../../../../utils/Languages.js'
import {escapedTemplate} from '../../../utils/escapeHtml.js'
import {addressLines, attachment, button, card, field, intro, mailDocument, multiline, stack} from './mailLayout.js'

const template = ({
    logo,
    color = '#ff751a',
    message,
    addressHeader = Languages.returnAddress.NL,
    referenceHeader = Languages.reference.NL,
    barcodeHeader = Languages.mailTrackTrace.NL,
    buttonText = Languages.followShipment.NL,
    attachmentName = 'Pakketlabel.pdf',
    parcel
}, baseUrl?: string) => {
    const senderAddress = parcel?.senderAddress || {}

    return mailDocument({
        logo,
        color,
        baseUrl,
        content: stack([
            intro(multiline(message)),
            card([
                field(addressHeader, addressLines(senderAddress)),
                parcel?.reference && field(referenceHeader, parcel.reference),
                field(barcodeHeader, parcel?.trackTrace || ''),
                attachment(attachmentName, baseUrl),
                button(buttonText, parcel?.trackTraceLink || null, color)
            ])
        ])
    })
}

export default escapedTemplate(template)
